import * as classNames from 'classnames';
import { DataService } from '../../../../services/data_service';
import { generateExcelFilter } from '../../../../core/table/filter/GenerateExcelFilter';
import { IDs } from '../../../../helpers/IDs';
import { i18n } from '../../../../i18n/i18n';
import { i18nLang } from '../../../../i18n/i18nLang';
import { lazyInject } from '../../../../services/inversify';
import { LocaleSelection } from './LocaleSelection';
import { Md5 } from 'ts-md5/dist/md5';
import * as React from 'react';
import style from './MehrsprachigkeitFormulare.less';
import { Translation } from './Translation';
import { TranslationButtons } from './TranslationButtons';
import { TranslationFilter } from './TranslationFilter';
import { TriggerService } from '../../../../core/trigger/trigger_service';
import { WSpinner } from '../../../../core/elements/spinner/WSpinner';
import { WTable } from '../../../../core/table/WTable';

interface MehrsprachigkeitFormulareProps extends React.ClassAttributes<any> {
    data: any;
}

interface MehrsprachigkeitFormulareState {
    entities: any[];
    entitySelected: any;
    filter: string;
    isSaving: boolean;
    item: any;
    locale: string;
    locales: any;
    mouseOverButtons: string;
    openedOptions: any;
    selectedOptionparts: any;
    showPreview: string;
}

export class MehrsprachigkeitFormulare extends React.Component<MehrsprachigkeitFormulareProps, MehrsprachigkeitFormulareState> {

    constructor(props: any) {
        super(props);
        const languageSelected: string = (props.data || {}).LANGUAGE_SELECTED || i18nLang.getUILang();
        this.state = {
            entities: null,
            entitySelected: null,
            filter: 'all',
            isSaving: false,
            item: null,
            locale: languageSelected,
            locales: { en: true, fr: true },
            mouseOverButtons: null,
            openedOptions: {},
            selectedOptionparts: {},
            showPreview: null
        };
        this.filterMethodString = this.filterMethodString.bind(this);
        this.init = this.init.bind(this);
        this.onResize = this.onResize.bind(this);
        this.wrapper = React.createRef();
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private locales: any = {};
    private Translation: any;
    private wrapper: any;


    componentDidMount(): void {
        window.addEventListener('resize', this.onResize);
        this.init(true);
    }

    componentDidUpdate(prevProps: any, prevState: any): void {
        const { isVerified, key, locale, text } = this.state.item || {};
        const item: any = ((this.props.data || {})[IDs.ENT_MEHRSPRACHIGKEIT] || [])
            .find((item: any) => item.intern_key === key && item.intern_key2 === 'entity') || {};
        const curText: string = item[locale];
        const curVerification: number = item[`${locale}_geprueft`];
        const languageSelected: string = (this.props.data || {}).LANGUAGE_SELECTED || i18nLang.getUILang();

        if (!(((this.wrapper || {}).current || {}).style || {}).height) {
            this.onResize();
        }

        if (languageSelected !== this.state.locale) {
            this.setState({ entities: null, locale: languageSelected }, this.init);
        }

        if (this.state.item && (curText === text || curVerification === +isVerified)) {
            this.setState({ item: null }, this.init);
        }

        if ((this.state.entitySelected || {}).id !== (prevState.entitySelected || {}).id) {
            this.initOpenedOptions();
            this.initSelectedOptionparts();
        }
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.onResize);
    }

    excelFilter(accessor: string): any {
        return ({ filter, onChange }: { filter: any, onChange: any }) =>
            generateExcelFilter(accessor, onChange, null, () => this.state.entities || [], 'CHAR191');
    }

    filterMethodExcel(accessor: string): any {
        return (filter: any, row: any) => ((filter || {}).value || '').toString().indexOf(row[accessor]) !== -1;
    }

    filterMethodString(filter: any, row: any): any {
        const filterValue: string = ((filter || {}).value || '').toString().toLowerCase();
        const valueCompare: string = ((row || {})[filter.id] || '').toString().toLowerCase();
        return valueCompare.indexOf(filterValue) !== -1
            || (row._subRows || []).find((item: any) => ((item || {})[filter.id] || '').toString().toLowerCase().indexOf(filterValue) !== -1);
    };

    getColumns(): any[] {
        const counter: string = i18n('Felder', 'sys');
        const group: string = i18n('Gruppe', 'sys');
        const name: string = i18n('Titel', 'sys');

        return [
            {
                id: 'group', accessor: 'group', Header: group, HeaderText: group, type: 'text', Filter: this.excelFilter('group'),
                filterMethod: this.filterMethodExcel('group')
            },
            {
                id: 'name', accessor: 'name', Header: name, HeaderText: name, type: 'text', filterMethod: this.filterMethodString,
                aggregate: () => { }
            },
            {
                id: 'counter', accessor: 'counter', Header: counter, HeaderText: counter, type: 'int', filterable: false
            }
        ];
    }

    getTranslationFilter(): any[] {
        return [
            { key: 'missing', name: i18n('fehlende', 'sys') },
            { key: 'missing_unverified', name: i18n('fehlende + ungeprüfte', 'sys') },
            { key: 'all', name: i18n('alle', 'sys') }
        ];
    }

    async init(reset?: boolean): Promise<void> {
        this.Translation = new Translation(this.props.data, this.dataService, this.triggerService, reset);
        this.locales = this.Translation.getLocales() || {};
        this.setState({ entities: await this.Translation.getEntities() }, () => console.info('INIT', this.locales, this.state.entities, this.state.openedOptions, this.state.selectedOptionparts, this.Translation.getData(), this.state.entitySelected));
    }

    initOpenedOptions(): void {
        const id: string = (this.state.entitySelected || {}).id || null;

        if (!id) {
            return;
        }
        let openedOptions: any = { [id]: {} };

        ((this.state.entitySelected || {}).fields || [])
            .filter((field: any) => !!((field || {}).options || []).length)
            .map((field: any) => openedOptions[id][field.index] = false);
        openedOptions = { ...openedOptions, ...this.state.openedOptions };
        this.setState({ openedOptions });
    }

    initSelectedOptionparts(): void {
        const id: string = (this.state.entitySelected || {}).id || null;

        if (!id) {
            return;
        }
        let selectedOptionparts: any = { [id]: {} };

        ((this.state.entitySelected || {}).fields || [])
            .filter((field: any) => !!((field || {}).optionparts || []).length)
            .map((field: any) => selectedOptionparts[id][field.index] = 0);
        selectedOptionparts = { ...selectedOptionparts, ...this.state.selectedOptionparts };
        this.setState({ selectedOptionparts });
    }

    isTranslationItemVisible(data: any): boolean {
        switch (this.state.filter) {
            case 'missing':
                return !data.isTranslated;
            case 'missing_unverified':
                return !data.isTranslated || !data.isVerified;
            default:
                return true;
        }
    }

    onChangeOptionparts(data: any): void {
        const id: string = (this.state.entitySelected || {}).id || null;
        const index: number = typeof data.index === 'number' ? data.index : null;
        const selectedOptionparts: any = { ...this.state.selectedOptionparts };
        const value: number = data.value || 0;

        if (typeof (selectedOptionparts[id] || {})[index] !== 'undefined') {
            selectedOptionparts[id][index] = value;
            this.setState({ selectedOptionparts });
        }
    }

    onResize(): void {
        const element: any = (this.wrapper || {}).current;

        if (!element) {
            return;
        }
        const height: number = window.innerHeight - element.offsetTop - 1;

        if (height !== element.clientHeight) {
            element.style.height = element.style.maxHeight = element.style.minHeight = `${height}px`;
        }
    }

    render(): JSX.Element {
        if (this.state.entities === null) {
            return <WSpinner />
        }

        return (
            <div key={`formulare-${this.state.locale}`}>
                <div className={style.action_bar}>
                    <LocaleSelection
                        data={this.locales}
                        label={`${i18n('Sprachen', 'sys')}:`}
                        onChange={(locales: any) => this.setState({ locales })}
                        selection={this.state.locales}
                    />
                    <TranslationFilter
                        filter={this.getTranslationFilter()}
                        label={`${i18n('Übersetzungen', 'sys')}:`}
                        onChange={(filter: any) => this.setState({ filter })}
                        value={this.state.filter}
                    />
                </div>
                <div ref={this.wrapper} className={style.wrapper}>
                    {this.renderTable()}
                    <div>
                        {this.state.entitySelected &&
                            <>
                                {this.renderTitle()}
                                {this.renderFields()}
                            </>
                        }
                    </div>
                    {this.state.isSaving && <WSpinner />}
                </div>
            </div>
        );
    }

    renderField(data: any): JSX.Element {
        const id: string = (this.state.entitySelected || {}).id || null;
        const options: any[] = (data || {}).options || [];
        const hasOptions: boolean = !!options.length;
        const classOptions: string = hasOptions
            ? ((this.state.openedOptions[id] || {})[data.index] ? 'opened' : 'closed')
            : 'none';

        return (
            <div
                className={classNames(style.field, style[classOptions])}
                onClick={() => hasOptions ? this.toggleOptions(data.index) : null}
            >
                {data.name || ''}
            </div>
        );
    }

    renderFields(): JSX.Element[] {
        return ((this.state.entitySelected || {}).fields || []).map((field: any, index: number) =>
            <React.Fragment key={`field-${index}`}>
                {this.renderField(field)}
                {this.renderTranslations(field)}
                {this.renderSelectOptionparts(field)}
                {this.renderOptions(field)}
            </React.Fragment>
        );
    }

    renderOption(data: any): JSX.Element {
        return <div className={style.option}>{data.name || ''}</div>;
    }

    renderOptions(data: any): JSX.Element[] {
        const id: string = (this.state.entitySelected || {}).id || null;

        if (!(this.state.openedOptions[id] || {})[data.index]) {
            return null;
        }
        const indexOptionparts: number = (this.state.selectedOptionparts[id] || {})[data.index] || 0;
        const options: any[] = ((data || {}).options || [])[indexOptionparts] || [];

        return options.map((option: any, index: number) =>
            <React.Fragment key={`option-${index}`}>
                {this.renderOption(option)}
                {this.renderTranslations(option)}
            </React.Fragment>
        );
    }

    renderSelectOptionparts(data: any): JSX.Element {
        const id: string = (this.state.entitySelected || {}).id || null;
        const optionparts: any[] = (data || {}).optionparts || [];

        if (!optionparts.length || !(this.state.openedOptions[id] || {})[data.index]) {
            return null;
        }

        return (
            <div className={style.optionparts}>
                <select
                    key='select-options'
                    id='select-options'
                    value={(this.state.selectedOptionparts[id] || {})[data.index]}
                    onChange={(event: any) => this.onChangeOptionparts({ index: data.index, value: event.target.value })}
                >
                    {optionparts.map((option: any, index: number) =>
                        <option
                            key={`options-${index}`}
                            value={index}
                        >
                            {option.name}
                        </option>
                    )}
                </select>
            </div>
        );
    }

    renderTable(): JSX.Element {
        return (
            <WTable
                entity={null}
                data={this.state.entities}
                customClass='Custom-ETA'
                columns={this.getColumns()}
                columnWidths={[120, 0, 50]}
                pageSize={1000}
                hideExport
                onAction={() => { }}
                customTdProps={(state: any, rowInfo: any, column: any) => {
                    const row: any = (rowInfo || {}).original || {};
                    const selected: any = this.state.entitySelected || {};
                    return row.id && row.id === selected.id
                        ? { style: { backgroundColor: '#bccae3' } } : {};
                }}
                customTrProps={(state: any, rowInfo: any, column: any) => {
                    const row: any = (rowInfo || {}).original || {};
                    return row.id
                        ? { onClick: () => this.setState({ entitySelected: row }), style: { cursor: 'pointer' } } : {};
                }}
            />
        );
    }

    renderTitle(): JSX.Element {
        const data: any = this.state.entitySelected || {};

        return <>
            <div className={style.title}>{data.name || ''}</div>
            {this.renderTranslations(data)}
        </>;
    }

    renderTranslationItem(data: any, locale: string): JSX.Element {
        const name: string = data.name || '';
        const id: string = Md5.hashAsciiStr(`[${locale}][${name}]`).toString();
        const isPreview: boolean = this.state.showPreview === id && this.state.mouseOverButtons === id;
        let classStatus: string = 'error';
        let text: string = name;
        this.Translation.getTranslation(name, locale, (item: any) => {
            data = { ...data, ...item };
            classStatus = item.isVerified
                ? 'success'
                : (item.isTranslated ? 'warning' : classStatus)
            text = item.text;
        });
        text = isPreview ? (TranslationButtons.previews[id] || {}).text : text;

        if (!this.isTranslationItemVisible(data)) {
            return null;
        }

        return (
            <div
                className={classNames(style.translation, style[classStatus])}
                onMouseEnter={() => this.setState({ mouseOverButtons: id })}
                onMouseLeave={() => this.setState({ mouseOverButtons: null })}
            >
                {this.state.mouseOverButtons === id &&
                    <TranslationButtons
                        data={data}
                        isSaving={(isSaving: boolean) => this.setState({ isSaving })}
                        locale={locale}
                        onChange={(item: any) => this.setState({ item })}
                        showPreview={(showPreview: string) => this.setState({ showPreview })}
                        Translation={this.Translation}
                    />
                }
                <div className={classNames(style.flag, style[`flag-${locale}`])} title={this.locales[locale] || ''} />
                <span className={isPreview ? style.preview_item : null}>
                    {text}
                </span>
            </div>
        );
    }
    
    renderTranslations(data: any): JSX.Element {
        return (
            <div>
                {Object.keys(this.locales || {})
                    .filter((locale: string) => this.state.locales[locale])
                    .map((locale: string, index: number) =>
                        <React.Fragment key={`translation-${index}`}>
                            {this.renderTranslationItem(data, locale)}
                        </React.Fragment>
                    )
                }
            </div>
        );
    }

    toggleOptions(index: number): void {
        const { entitySelected, openedOptions } = this.state;
        const id: string = entitySelected.id || null;

        if (!openedOptions[id]) {
            return;
        }
        openedOptions[id][index] = typeof openedOptions[id][index] === 'undefined' ? true : !openedOptions[id][index];
        this.setState({ openedOptions });
    }
}
